import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class PcalendarLanguageService {

	constructor() {
	}

	public traduire(langue: string) {
		if (langue && langue.toLocaleLowerCase() === 'it') {
			return this.italien();
		}
		else {
			return this.francais();
		}
	}

	private francais() {
		return {
			clear: 'Effacer',
			prevText: 'Précédent',
			nextText: 'Suivant',
			today: 'Aujourd\'hui',
			monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			monthNamesShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
			dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
			dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
			dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
			weekHeader: 'Sem.',
			dateFormat: 'dd/mm/yy',
			firstDayOfWeek: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''
		};
	}

	private italien() {
		return {
			clear: 'Cancellare',
			prevText: 'Precedente',
			nextText: 'Seguente',
			today: 'Oggi',
			monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
			monthNamesShort: ['Gen.', 'Feb.', 'Mar.', 'Apr.', 'Mag.', 'Giu.', 'Lug.', 'Ago.', 'Set.', 'Ott.', 'Nov.', 'Dic.'],
			dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
			dayNamesShort: ['Dom.', 'Lun.', 'Mar.', 'Mer.', 'Gio.', 'Ven.', 'Sab.'],
			dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
			weekHeader: 'Set.',
			dateFormat: 'dd/mm/yy',
			firstDayOfWeek: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''
		};
	}
}
